import { getSidebarCollapsed } from 'gcs-common/slices/uiState/uiStateSelectors';
import { useSelector } from 'react-redux';
import AgentChannelListCollapsed from '../AgentChannelListCollapsed/AgentChannelListCollapsed';
import AgentChannelListNormal from '../AgentChannelListNormal/AgentChannelListNormal';
import styles from './styles.module.scss';

function AgentChannelListWrapper() {
  const sidebarCollapsed = useSelector(getSidebarCollapsed);

  return (
    <div className={styles.channelListWrapper}>
      {sidebarCollapsed ? <AgentChannelListCollapsed /> : <AgentChannelListNormal />}
    </div>
  );
}

export default AgentChannelListWrapper;

AgentChannelListWrapper.propTypes = {};
